export const environment = {
  production: true,
  apiUrl: 'https://app-vivinio.herokuapp.com',
};

// export const environment = {
//   production: false,
//   apiUrl: 'http://localhost:3000',
// };
